import { Checkbox } from "@/components/ui/checkbox";
import { Database } from "@/integrations/supabase/types";

type Weekday = Database["public"]["Enums"]["weekday"];

interface DayListProps {
  selectedDays: Weekday[];
  onDayToggle: (day: Weekday) => void;
  days: { value: Weekday; label: string }[];
}

export const DayList = ({ selectedDays, onDayToggle, days }: DayListProps) => {
  return (
    <div className="space-y-4">
      {days.map((day) => (
        <div key={day.value} className="flex items-center space-x-2">
          <Checkbox
            id={day.value}
            checked={selectedDays.includes(day.value)}
            onCheckedChange={() => onDayToggle(day.value)}
          />
          <label
            htmlFor={day.value}
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            {day.label}
          </label>
        </div>
      ))}
    </div>
  );
};